import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'
import { getOrdersSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { getOrders } from '../App/actions'

const OrdersLoader = () => {
  const dispatch    = useDispatch()
  const orders      = useSelector(state => state.toJS().global.orders)
  const agencytoken = useSelector(state => state.toJS().global.agencytoken)
  const isAdmin     = useSelector(state => state.toJS().global.isAdmin)

  useEffect(() => {
    if (!isAdmin && orders == null && agencytoken != null) {
      dispatch(getOrders(agencytoken))
    }
  }, [orders, agencytoken, isAdmin])

  return <div />
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'OrdersLoader', saga: getOrdersSaga })
export default compose(withSaga, withConnect)(OrdersLoader)
